import {Address} from "../address/address";

export class User {

  /**
   * Only provided by the server in CSRMODE
   */
  private _dateOfBirth: string;
  private _firstName: string;
  private _lastName: string;
  private _phoneMobile: string; // mobile number
  private _phoneFixed: string; // landline number or other than mobile
  private _emailAddress: string;
  private _address: Address;
  private _billingAccountId: string;
  private _fullName: string;
  private _userId: string;
  private _simActivated: boolean;
  private _migratedFrom: string;
  private _migratedFromAccountId: string;
  private _migratedTo: string;
  private _migratedToAccountId: string;
  private _nougatMigrationOffer: string;
  private _migratedIp: boolean;

  get fullName(): string {
    return this._fullName;
  }

  set fullName(value: string) {
    this._fullName = value;
  }

  get userId(): string {
    return this._userId;
  }

  get billingAccountId(): string {
    return this._billingAccountId;
  }

  set billingAccountId(value: string) {
    this._billingAccountId = value;
  }

  set userId(value: string) {
    this._userId = value;
  }

  get phoneMobile(): string {
    return this._phoneMobile;
  }

  set phoneMobile(value: string) {
    this._phoneMobile = value;
  }

  get phoneFixed(): string {
    return this._phoneFixed;
  }

  set phoneFixed(value: string) {
    this._phoneFixed = value;
  }

  get simActivated(): boolean {
    return this._simActivated;
  }

  set simActivated(value: boolean) {
    this._simActivated = value;
  }


  get firstName(): string {
    return this._firstName;
  }

  set firstName(value: string) {
    this._firstName = value;
  }

  get lastName(): string {
    return this._lastName;
  }

  set lastName(value: string) {
    this._lastName = value;
  }

  get emailAddress(): string {
    return this._emailAddress;
  }

  set emailAddress(value: string) {
    this._emailAddress = value;
  }

  get dateOfBirth(): string | null {
    return this._dateOfBirth;
  }

  set dateOfBirth(value: string | null) {
    this._dateOfBirth = value;
  }

  get address(): Address {
    return this._address;
  }

  set address(value: Address) {
    this._address = value;
  }

  get migratedFrom(): string {
    return this._migratedFrom;
  }

  set migratedFrom(value: string) {
    this._migratedFrom = value;
  }

  get migratedFromAccountId(): string {
    return this._migratedFromAccountId;
  }

  set migrateFromAccountId(value: string) {
    this._migratedFromAccountId = value;
  }

  get migratedTo(): string {
    return this._migratedTo;
  }

  set migratedTo(value: string) {
    this._migratedTo = value;
  }

  get migratedToAccountId(): string {
    return this._migratedToAccountId;
  }

  set migratedToAccountId(value: string) {
    this._migratedToAccountId = value;
  }

  get nougatMigrationOffer(): string {
    return this._nougatMigrationOffer;
  }

  set nougatMigrationOffer(value: string) {
    this._nougatMigrationOffer = value;
  }

  get migratedIp(): boolean {
    return this._migratedIp;
  }

  set migratedIp(value: boolean) {
    this._migratedIp = value;
  }
}
